







































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RowHeader extends Vue {
  private riskSort (name: string) {
    this.$emit('risk-sort', name)
  }
}
